export const MENU_WIDTH = 300
